import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import '@/styles/globals.css';
import { router } from '@/route/router';
import { bootI18n } from './services/i18n';

const TELEMETRY_INIT_TIMEOUT_MS = 2000;

const initializeTelemetry = async () => {
  try {
    const telemetry = await import('./otel');
    await telemetry.initializeTelemetry();
  } catch (error) {
    console.error('Failed to initialize telemetry:', error);
  }
};

await Promise.race([
  initializeTelemetry(),
  new Promise<void>((resolve) => {
    setTimeout(resolve, TELEMETRY_INIT_TIMEOUT_MS);
  }),
]);
await bootI18n();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
